import { parseBooleanEnv } from './config';

// Feature flags are resolved at build time from environment variables.
// To add a flag: (1) add an entry here, (2) add the env var to .env.example.
const featureFlags = {
    appleLogin: parseBooleanEnv(process.env.REACT_APP_FEATURE_APPLE_LOGIN, false),
    marketplaceCart: parseBooleanEnv(process.env.REACT_APP_FEATURE_MARKETPLACE_CART, false),
    billingPeriodVisibilityExperiment: parseBooleanEnv(process.env.REACT_APP_FEATURE_BILLING_PERIOD_VISIBILITY_EXPERIMENT, false),
};

export default featureFlags;
